export default "__VITE_ASSET__BcfE5r96__"